// src/components/MetricExplainer.tsx
//
// "Why is this % different on another page?" — a collapsed note that names the
// metric a card shows and defines all three side by side. Shared so every
// surface explains the difference in the same words (src/lib/progress/
// metric-labels.ts). A native <details>: no JS, works on touch (a title
// tooltip does not), and costs one line until opened.

import { METRIC_LABELS, WHY_RECENT_DIFFERS, type MetricKey } from '@/lib/progress/metric-labels'

const ORDER: MetricKey[] = ['allTime', 'recent', 'mastery']

export default function MetricExplainer({
  shows,
  className = '',
}: {
  /** The metric(s) the surrounding card displays. */
  shows: MetricKey | MetricKey[]
  className?: string
}) {
  const shown = Array.isArray(shows) ? shows : [shows]
  const names = shown.map((k) => METRIC_LABELS[k].name)
  return (
    <details className={`text-[11px] text-muted-foreground ${className}`}>
      <summary className="cursor-pointer select-none hover:text-foreground">
        Why might this % differ elsewhere?
      </summary>
      <div className="mt-1.5 space-y-1.5">
        <p>
          This shows <span className="font-semibold text-foreground">{names.join(' and ')}</span>.
        </p>
        <dl className="space-y-1">
          {ORDER.map((k) => (
            <div key={k}>
              <dt className="inline font-semibold text-foreground">{METRIC_LABELS[k].name}: </dt>
              <dd className="inline">{METRIC_LABELS[k].explain}</dd>
            </div>
          ))}
        </dl>
        <p>{WHY_RECENT_DIFFERS}</p>
      </div>
    </details>
  )
}
